import { render, staticRenderFns } from "./ListNews.vue?vue&type=template&id=2ee3402c&scoped=true"
import script from "./ListNews.vue?vue&type=script&lang=js"
export * from "./ListNews.vue?vue&type=script&lang=js"
import style0 from "./ListNews.vue?vue&type=style&index=0&id=2ee3402c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee3402c",
  null
  
)

export default component.exports